import { POST } from '@/api'
import getCookie from '@/utils/getCookie'

export default {
  namespaced: true,
  state: {
    data: null,
    xhrEvent: null,
    busy: false,
  },
  mutations: {
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {},
  actions: {
    async download({ commit, state }, range) {
      commit('busy', true)

      const path = [2, 4].includes(range) ? 'download_history' : 'download'
      if (STAGE === STAGE_LOCAL) {
        // ローカル用
        const { status, message } = await POST(`/api/web/customer/csv/${path}`, { range })
        if (status !== 200) {
          commit('app/error', { status, message }, { root: true })
        }

        commit('busy', false)
        return status === 200
      }
      const request = () => {
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest()
          xhr.open('POST', window.location.origin + `/api/web/customer/csv/${path}`, true)
          xhr.setRequestHeader('X-CSRF-TOKEN', getCookie('csrf_cookie'))
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
          xhr.responseType = 'blob'
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                resolve(xhr)
              } else {
                reject(xhr)
              }
            }
          }
          xhr.send('range=' + range)
        })
      }
      const fetchData = async () => {
        try {
          const response = await request()
          state.data = response
          commit('busy', false)
          return response.status === 200
        } catch (error) {
          commit('busy', false)
          return false
        }
      }

      return fetchData()
    },
    async upload(store, customerCsv) {
      const { commit } = store
      commit('busy', true)

      const { status, message } = await POST('/api/web/customer/csv/upload', customerCsv)
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
